/* eslint-disable no-unused-vars */

import { jsPDF } from "jspdf";

import { createHeaderSenado } from "../../../model/header";
import { createFooterSenado } from "../../../model/footer";
import moment from "moment";


export function relatoriodepreciacao(relatorio, title) {

  var ibp = relatorio.itemBemPermanente;
  var historico = relatorio.historico

  const doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "landscape",
  });
  createHeaderSenado(doc, title)

  doc.setFont("", "bold");

  doc.text(`PERÍODO: ${relatorio.periodo}`, 10, 40, null, null, "left");


  doc.text(`DESCRIÇÃO: ${ibp.itemRegEntrada.produto.descricaoResumida}`, 10, 44, null, null, "left");


  doc.text(`Nº TOMBAMENTO: ${ibp.numTombamento}`, 10, 48, null, null, "left");

  doc.text(
    `Nº TOMBAMENTO SAMP: ${ibp.s_numTombAntigo?ibp.s_numTombAntigo: ''}`,
    10,
    52,
    null,
    null,
    "left"
  );


  doc.text(
    `DATA AQUISIÇÃO: ${  moment(String(ibp.dataEntrada)).format("DD/MM/YYYY")}`,
    10,
    56,
    null,
    null,
    "left"
  );

  doc.text(
    `VALOR AQUISIÇÃO: R$ ${ibp.valorOriginal.toFixed(2)}`,
    10,
    60,
    null,
    null,
    "left"
  );

  doc.text(
    `DATA INÍCIO DEPRECIAÇÃO: ${moment(ibp.dataEntrada).add(1, 'months').format("DD/MM/YYYY")}`,
    10,
    64,
    null,
    null,
    "left"
  );

  doc.text(
    `VALOR ATUAL: R$ ${relatorio.valorAtual.toFixed(2)}`,
    10,
    68,
    null,
    null,
    "left"
  );

  doc.text(
    `NATUREZA DESPESA: ${ibp.naturezaDespesa.numero + " - " + ibp.naturezaDespesa.descricao}`,
    10,
    72,
    null,
    null,
    "left"
  );

  doc.text(
    `NATUREZA CONTÁBIL: ${ibp.naturezaDespesa.contaContabil?(ibp.naturezaDespesa.contaContabil.numeroFmt + ' - ' + ibp.naturezaDespesa.contaContabil.descricao):''}`,
    10,
    76,
    null,
    null,
    "left"
  );


  

  var dados = [];


  historico.forEach(function (dado) {

    dados.push({ data: dado.data, valorDepreciacao: dado.valorDepreciacao, valorReavaliado: dado.valorReavaliado, valor: dado.valor })

  });


  
  const generateDataTarefa = () => {
    const result = [];

    if (historico) {
      historico.map((c) => {
        result.push({
          "DATA": c.data,
          "VALOR DEPRECIAÇÃO(R$)": c.valorDepreciacao.toFixed(2).toString(),
          "VALOR REAVALIDADO(R$)": c.valorReavaliado.toFixed(2).toString(),
          "VALOR(R$)": c.valor.toFixed(2).toString()
        });
      });
    }

    return result;
  };



  var headersTarefa = [
    "DATA",
    "VALOR DEPRECIAÇÃO(R$)",
    "VALOR REAVALIDADO(R$)",
    "VALOR(R$)"
  ];

  doc.text(
    `VALOR ANTERIOR(R$): ${relatorio.valorAnterior.toFixed(2)}`,
    10,
    80,
    null,
    null,
    "left"
  );


  doc.setFont("", "normal");
  

  doc.table(10, 84, generateDataTarefa(), headersTarefa);

  createFooterSenado(doc)

  doc.save("Relatório Depreciação de Bem Permanente");
}